import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools')({
  component: RouteComponent,
  staticData: {
    crumb: {
        label: 'Tools',
    }
  }
})

function RouteComponent() {
  return <Outlet />
}
